import React, { useEffect, useState } from "react"
import Select from "react-select"

import MetaTags from "react-meta-tags"
import {
  Table,
  CardTitle,
  CardSubtitle,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Label,
  Row,
} from "reactstrap"
import { withRouter } from "react-router-dom"
import { formValidation, mapDataForDropDown } from "helpers/helpers"

//Date Picker
import "react-datepicker/dist/react-datepicker.css"

import "assets/scss/datatables.scss"
import { useSelector, useDispatch } from "react-redux"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { apiError } from "store/actions"
import { getAllProductChannels } from "store/channels/actions"
import { getAllSuppliers } from "store/suppliers/actions"
import FieldValidation from "../../../components/Common/FieldValidation"
import { getAllMultiBetBonusesCall } from "helpers/repository"
import { updateMultiBetBonus } from "store/MultiBetBonus/actions"
import {sitename} from "../../../constants/constants";
const Edit = props => {
  const Channels = useSelector(state => state.productChannels.Index ?? [])
  const Suppliers = useSelector(state => state.suppliers.Index ?? [])
  const urlParams = new URLSearchParams(props.location.search)

  const dispatch = useDispatch()
  const [max_selection, set_max_selection] = useState([])
  const [name, set_name] = useState("")
  const [suppliers, set_suppliers] = useState([])
  const [channels, set_channels] = useState([])
  const [description, set_description] = useState("")
  const [is_active, set_is_active] = useState(false)
  const [percentages, set_percentages] = useState([])
  const [minimum_odds, set_minimum_odds] = useState("")
  const [category, setCategory] = useState([])

  useEffect(() => {
    dispatch(getAllSuppliers())
    dispatch(getAllProductChannels())
    getAllMultiBetBonusesCall().then(res => {
      let obj = res.data.data.filter(bn => bn["id"] == urlParams.get("id"))
      obj = obj.length > 0 ? obj[0] : {}
      set_percentages(JSON.parse(obj["percentages"]))
      set_suppliers(mapDataForDropDown(obj.suppliers))
      set_channels(mapDataForDropDown(obj.channels))
      set_name(obj["name"])
      set_description(obj["description"])
      set_is_active(obj?.is_active)
      set_minimum_odds(obj?.minimum_odds)
    })
  }, [])

  useEffect(() => {
    setCategory(Suppliers.filter((item) => item.name === "BetBalancer"));
  }, [Suppliers])

  const handleSubmit = e => {
    e.preventDefault()
    const data = {
      id: urlParams.get("id"),
      product_channel_id: channels.map(item => item.id),
      supplier_id: suppliers.map(item => item.id),
      name: name,
      description: description,
      percentages: percentages,
      is_active: is_active,
      max_selection: 40,
      minimum_odds: minimum_odds,
    }
    dispatch(updateMultiBetBonus(data, props.history))
  }
  const formErrors = useSelector(state => state?.CommonState)

  const removeError = key => {
    let e = _.cloneDeep(formErrors)
    delete e[key]
    dispatch(apiError(e))
  }

  const handleSupplierChange = item => {
    set_suppliers(item)
  }
  const handleChannelChange = c => {
    set_channels(c)
  }
  
  const handleSelectionChange = (selection, value) => {

    let indexOfItem = percentages.findIndex(x => x.selection === selection);

    let tempPercentages = [...percentages];

    if (indexOfItem !== -1) {
        tempPercentages[indexOfItem] = {
            selection,
            value,
        };
    } else {
        tempPercentages.push({
            selection,
            value,
        });
    }
    set_percentages(tempPercentages);
};
  const getVal = item => {
    let val = percentages.find((o, i) => {
      if (o.selection == item && ![undefined, null, ""].includes(o.value)) {
        return o.value
      }
    })
    if (val && val.value) {
      return val.value
    }
  }
  const getRows = item => {
    return (
      <div className="row mb-4">
        <Col lg={3}>
          <label className="form-label">{`${item} selection`}</label>
          <input
            className="form-control"
            type="text"
            onChange={e => {
              handleSelectionChange(item, e.target.value)
            }}
            value={getVal(item)}
          />
        </Col>
        <Col lg={3}>
          <label className="form-label">{`${item + 10} selection`}</label>
          <input
            className="form-control"
            type="text"
            onChange={e => {
              handleSelectionChange(item + 10, e.target.value)
            }}
            value={getVal(item + 10)}
          />
        </Col>
        <Col lg={3}>
          <label className="form-label">{`${item + 20} selection`}</label>
          <input
            className="form-control"
            type="text"
            onChange={e => {
              handleSelectionChange(item + 20, e.target.value)
            }}
            value={getVal(item + 20)}
          />
        </Col>
        <Col lg={3}>
        <label className="form-label">
            {item + 30 == 40 ? `${item + 30}+ selection` : `${item + 30} selection`}
          </label>
          <input
            className="form-control"
            type="text"
            onChange={e => {
              handleSelectionChange(item + 30, e.target.value)
            }}
            value={getVal(item + 30)}
          />
        </Col>
      </div>
    )
}

  const _renderTable = () => {
    let currentUser
    let groupedMessages = []

    for (const selection of percentages) {
      if (selection.value !== currentUser) {
        groupedMessages.push([])
        currentUser = selection.value
      }
      groupedMessages[groupedMessages.length - 1].push(selection)
    }
    let pills = []
    groupedMessages.forEach(gp => {
      let from = gp[0].selection
      let to = gp[gp.length - 1].selection
      if (![undefined, null, ""].includes(gp[0].value) && from !== to) {
        pills.push({ from: from, to: to, value: gp[0].value })
      } else if (![undefined, null, ""].includes(gp[0].value) && from === to) {
        pills.push({ from: from, value: gp[0].value })
      }
    })
    return pills.map(item => {
      return (
        <>
          <tr>
            {[undefined, null, ""].includes(item.to) ? (
              <>
                <td className="text-center">{`${item.from}`}</td>
                <td className="text-center">{`${item.value}%`}</td>
              </>
            ) : (
              <>
                <td className="text-center">{`${item.from} to ${item.to}`}</td>
                <td className="text-center">{`${item.value}%`}</td>
              </>
            )}
          </tr>
        </>
      )
    })
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Bonuses" breadcrumbItem="Edit" />
          <Card>
            <h5 className="card-header bg-transparent border-bottom text-uppercase">
              Multibet Bonus Information Form
            </h5>

            <CardBody>
              <Form onSubmit={handleSubmit}>
                <div className="row mb-4">
                  <Col lg={3}>
                    <label className="form-label">Name</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="kiron-default"
                      onChange={e => {
                        removeError("name")
                        set_name(e.target.value)
                      }}
                      value={name}
                    />
                    {formErrors?.name ? (
                      <FieldValidation errorMessage={formErrors?.name} />
                    ) : null}
                  </Col>
                  <Col lg={3}>
                    <label className="form-label">Category/Supplier</label>
                    <Select
                      maxMenuHeight={150}
                      isMulti={true}
                      onChange={item => {
                        removeError("supplier_id")
                        handleSupplierChange(item)
                      }}
                      options={mapDataForDropDown(category)}
                      classNamePrefix="select2-selection"
                      value={suppliers}
                    />
                    {formErrors?.supplier_id ? (
                      <FieldValidation errorMessage={formErrors?.supplier_id} />
                    ) : null}
                  </Col>
                  <Col lg={3}>
                    <label className="form-label">Channels</label>
                    <Select
                      maxMenuHeight={150}
                      isMulti={true}
                      options={mapDataForDropDown(Channels)}
                      classNamePrefix="select2-selection"
                      onChange={e => {
                        removeError("product_channel_id")
                        handleChannelChange(e)
                      }}
                      value={channels}
                    />
                    {formErrors?.product_channel_id ? (
                      <FieldValidation
                        errorMessage={formErrors?.product_channel_id}
                      />
                    ) : null}
                  </Col>
                  <Col lg={3}>
                    <label className="form-label">Minimum Odds</label>
                    <input
                      className="form-control"
                      type="number"
                      min="0.1"
                      step="0.1"
                      onChange={e => {
                        removeError("minimum_odds")
                        set_minimum_odds(e.target.value)
                      }}
                      value={minimum_odds}
                    />
                    {formErrors?.minimum_odds ? (
                      <FieldValidation
                        errorMessage={formErrors?.minimum_odds}
                      />
                    ) : null}
                  </Col>
                </div>
                <div className="row mb-4">
                  <Col lg={4}>
                    <div className="row mb-4">
                      <Col lg={12}>
                        <label className="form-label">Description</label>
                        <textarea
                          className="form-control"
                          id="subject"
                          rows="5"
                          onChange={e => {
                            set_description(e.target.value)
                          }}
                          value={description}
                        />
                      </Col>
                    </div>
                    <div className="row mb-4">
                      <Col lg={12}>
                        <Card>
                          <CardBody>
                            <CardTitle>Bonus Rules Generated</CardTitle>

                            <div
                              className="table-responsive"
                              style={{ height: "300px" }}
                            >
                              <Table className="table mb-0">
                                <thead className="table-light">
                                  <tr>
                                    <th className="text-center">selection</th>
                                    <th className="text-center">percentage</th>
                                  </tr>
                                </thead>

                                <tbody>{_renderTable(percentages)}</tbody>
                              </Table>
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    </div>
                  </Col>
                  <Col lg={8}>
                    <Card>
                      <CardBody>
                        <CardTitle>Bonus Percentages</CardTitle>
                        <div className="row mb-4">
                          {[1, 2, 3, 4, 5,6,7,8,9,10].map((item, index) => {
                            return (
                              <>
                                <Col lg={12}>{getRows(item, index)}</Col>
                              </>
                            )
                          })}
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </div>
                <div className="d-flex flex-wrap gap-2">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="defaultCheck1"
                      onChange={() => set_is_active(!is_active)}
                      checked={is_active}
                      defaultChecked={is_active}
                    />
                    <label className="form-check-label" htmlFor="defaultCheck1">
                      Is Active?
                    </label>
                  </div>
                </div>
                <div className="d-flex flex-wrap gap-2 justify-content-end">
                  <Button type="submit" color="primary" className="">
                    Save
                  </Button>{" "}
                  <Button
                    type="reset"
                    color="secondary"
                    className=""
                    onClick={() => {
                      props.history.push("/promotions/multibet-bonus")
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}
export const EditMultiBetBonus = withRouter(Edit)
